module.exports = __webpack_public_path__ + "static/media/yo-dawg-branches.d0bdc9fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/git-more-done/assets/yo-dawg-branches.jpg
// module id = 390
// module chunks = 0